export const webhook = {
  field: {
    url: 'URI',
    type: 'Тип'
  },
  
  button: {
    create: 'Создать вебхук',
    disabled: 'Все вебхуки уже созданы'
    
  },

  input: {
    disabled: 'Все типы вебхуков уже созданы'
  },

  modal: {
    create: 'Создание вебхука',
    edit: 'Изменение вебхука',
    remove: {
      content: 'Вы уверены что хотите удалить вебхук {type}?'
    }
  },

  webhook_type: {
    call_interrupted: 'Звонок прервался',
    op_disconnected: 'Оператор отключен',
    op_active: 'Оператор активен',
    op_inactive: 'Оператор неактивен',
    call_restored: 'Вызов восстановлен',
    call_started: 'Звонок начался',
    call_client_answered: 'Клиент ответил',
    call_failed: 'Звонок не удался',
    call_finished: 'Звонок закончен',
    task_success: 'Задача выполнена',
    task_failed: 'Задача не выполнена',
    recording_ready: 'Запись готова',
    op_deactivating: 'Деактивация оператора',
    call_connected: 'Вызов подключен',
    op_connected: 'Оператор подключен',
    amd_result: 'Определение автоответчика'
  }
}